module.exports = __webpack_public_path__ + "static/media/38.1e651c5b.mp4";